// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__irR44","list":"PatternAutocomplete_list__KbOVl"};